<template>
  <ValidationProvider
    :vid="vid"
    :name="$attrs.name"
    :rules="rules"
    v-slot="{ valid, errors }"
  >
    <div v-bind:class="{'mb-1': errors[0], '': !errors[0]}" v-bind="$attrs">
      <date-picker
        class="w-100"
        v-model="innerValue"
        v-bind="$attrs"
        v-bind:class="{'datepicker-input-reg': true, 'is-invalid': errors[0]}"
        :state="errors[0] ? false : valid ? true : null"
        :min="min"
        :max="max"
        value-type="format"
        format="YYYY-MM-DD"
      ></date-picker>
      <b-form-invalid-feedback class="text-left" style="margin-bottom:5px" id="inputLiveFeedback">{{
        errors[0]
      }}</b-form-invalid-feedback>
    </div>
  </ValidationProvider>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components:{
    DatePicker
  },
  props: {
    min: {
      type: Date
    },
    max: {
      type: Date
    },
    vid: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: ""
  }),
  watch: {
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
